import LandingPage from './Pages/Landing';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import About from './Pages/About';
import './App.css';
import Programs from './Pages/Programs';
import Contact from './Pages/Contact';
import Support from './Pages/Support';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </Router>
  );
}

export default App;
